import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../../icons/OnEditIcon';
import { formatDate } from '../../../../utils/dateFunctions';

import table from '../../../../commonStyles/tables.module.css';
import local from './steps.module.css';


const StepsRow = ({ row, isDisabled, isDeleteDisabled, onEdit, onDelete }) => {
    return (
        <TableRow hover className={table.basicRowStripes}>
            <TableCell>{formatDate(row.date) ?? ' - '}</TableCell>
            <TableCell>
                <span className={local.alignRow}>{row.value}</span>
            </TableCell>
            <TableCell>
                <span className={`${!row.linkedModule ? local.alignLinkRow : ''}`}>
                    {row.linkedModule ?? ' - '}
                </span>
            </TableCell>
            <TableCell align="right">
                <OnEditIcon onEdit={(e) => onEdit(e, row)} active={!isDisabled} />
            </TableCell>
            <TableCell align="right">
                <OnDeleteIcon onDelete={() => onDelete(row)} active={!isDeleteDisabled} />
            </TableCell>
        </TableRow>
    );
};

StepsRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    isDeleteDisabled: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func
};

export default StepsRow;
